import { css } from "styled-components";
import { media } from "@nested/brand";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";

const wrapperStyle = css`
  height: auto;
  background-color: ${({ theme }) => theme.palette.pink20};
  max-width: 100vw;
  width: 100%;
  box-sizing: border-box;
  margin: 20px 0;
  padding: 20px 0 0;
`;

const contentStyle = css`
  margin: auto;
  max-width: 534px;
  padding: 0 20px;
`;

const headingStyle = css`
  color: ${({ theme }) => theme.palette.hague130};
  font-size: 18px;
  margin: 0;
  line-height: 22px;
  font-weight: 500;
`;

const paragraphStyle = css`
  color: ${({ theme }) => theme.palette.hague130};
  font-size: 14px;
  line-height: 17px;
  margin-top: 10px;
  margin-bottom: 20px;

  ${media.tablet`
    font-size: 16px;
    line-height: 24px;
    margin-bottom: 15px;
  `}
`;

const linkStyle = css`
  display: block;
  border-top: 1px solid ${({ theme }) => theme.palette.pink100};
  border-bottom: 1px solid ${({ theme }) => theme.palette.pink100};
  margin-top: 20px;
  width: 100%;
  padding: 15px 0px;
  font-weight: 500;
  text-decoration: none;
`;

const iconStyle = css`
  float: right;
`;

export const BannerCTA = ({ heading, text, button_label, button_link }) => (
  <div css={wrapperStyle}>
    <div css={contentStyle}>
      <h3 css={headingStyle}>{heading}</h3>
    </div>
    <div css={contentStyle}>
      <p css={paragraphStyle}>{text}</p>
    </div>
    <a css={linkStyle} href={button_link.url} target={button_link.target}>
      <div css={contentStyle}>
        {button_label}
        <div css={iconStyle}>
          <FontAwesomeIcon icon={faArrowRight} />
        </div>
      </div>
    </a>
  </div>
);
